



































import Vue from 'vue'
import ProductCard from '@/top/components/ProductCard.vue'
import { TopProductItem } from '@/top/types'
//@ts-ignore
import Swiper from 'swiper/dist/js/swiper.min.js'
import chunk from 'lodash/chunk'

const MOBILE_BREAKPOINT = 768
export default Vue.extend({
  name: 'ProductCarousel',
  components :{
    ProductCard
  },
  props: {
    carouselName: {
      type: String,
      required: true
    },
    productItems: {
      type: Array as () => TopProductItem[],
      required: true
    },
    slideChunkSize: {
      type: Number,
      default: 4
    },
    showCarouselBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      swiper: undefined,
      currentPage: 1
    }
  },
  computed: {
    totalPage(): number {
      return this.chunkProductItems.length
    },
    chunkProductItems(): TopProductItem[][] {
      const chunkSize = this.isDesktopView ? this.slideChunkSize : 1
      return chunk(this.productItems, chunkSize)
    },
    isDesktopView(): boolean {
      return window.innerWidth > MOBILE_BREAKPOINT
    }
  },
  mounted() {
    const className = this.carouselName || 'tp-ProdCarousel_Wrapper'
    this.swiper = new Swiper(`.${className}`, {
      spaceBetween: 0,
      pagination: false,
      slidesPerView: this.isDesktopView ? 1 : 1.5,
      lazy: {
        loadPrevNext: false
      },
      navigation: {
        prevEl: `.${className} .tp-ProdCarousel_BtnPrev`,
        nextEl: `.${className} .tp-ProdCarousel_BtnNext`
      }
    })
    this.updatePager()
  },
  methods: {
    updatePager() {
      if (this.isDesktopView) {
        this.$emit('updatePager', {currentPage: this.currentPage, totalPage: this.totalPage})
      }
    },
    previousPage(){
      this.currentPage = --this.currentPage
      this.updatePager()
    },
    nextPage(){
      this.currentPage = ++this.currentPage
      this.updatePager()
    }
  }
})
